// PostCard.js
import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import ReactMarkdown from 'react-markdown';

import { UserSearch } from 'lucide-react';

import placeholderSmall from "assets/images/info/card-placeholder-small.png";

import axiosInstance from 'utils/axiosInstance';

const PostCard = ({ post, imageMap }) => {

  return (
    <div className="mb-4 pb-4 border-bottom">
      {post.topics?.length > 0 && (
        <div className="mb-2">
          {post.topics.map((topic, i) => (
            <span
              key={i}
              className="badge bg-secondary me-1"
              style={{ fontSize: '0.75rem' }}
            >
              #{topic}
            </span>
          ))}
        </div>
      )}

      <div style={{ margin: "10px 0px 8px 0px" }} className="d-flex justify-content-between">
        <div className="d-flex">
          <img src={imageMap[post.profileImage] || placeholderSmall} alt="preview" 
            style={{
              height: "40px",
              width: "40px",
              objectFit: "cover",
              borderRadius: "50%",
              border: "1px solid #6c97d1",
              marginRight: "10px"
            }} 
          />
          <div style={{ marginTop: "2.7px", marginRight: "10px" }}>
            <p className="mb-0">{post?.questionSetLabel}</p>
            <p className="mb-0" 
              style={{ 
                fontSize: "10.5px",
                color: "#9b9b9b"
              }}
            >{post?.topicLabel}</p>
          </div>
        </div>
        {post?.pointReward?.hasReward && 
          <div className="d-flex justify-content-end align-items-start" 
            style={{ paddingTop: "5px", paddingRight: "10px", minWidth: "80px", cursor: "pointer" }}
          >
            <div className="info-feed-post-point-btn"
              style={{
                padding: "2px 5px",
                border: "1px solid #4e99e1",
                borderRadius: "3px"
              }}
            >
              <p className="mb-0 info-feed-post-point-text" 
                style={{ fontWeight: 400, fontSize: "9.5px" }}>
                {`TTpoint ${post?.pointReward?.amount || 0}`}
              </p>
            </div>
          </div>
        }
      </div>

      <div style={{ cursor: "pointer", marginTop: "15px", marginBottom: "12px" }}>
        {post.format === 'md'
          ? <ReactMarkdown>{post.text}</ReactMarkdown>
          : <p>{post.text}</p>}
      </div>

      <div className="scroll-container-no-scrollbar"
        style={{ overflowX: "auto", whiteSpace: "nowrap", paddingBottom: "5px",
          marginBottom: "6px", scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        <div className="d-flex align-items-center" style={{ width: "max-content" }}>
          {post.images?.length > 0 && post.images?.map((imageName, idx) => (
            <div key={idx} style={{ position: "relative", cursor: "pointer" }}>
              <img
                src={imageMap[imageName] || placeholderSmall}
                alt={`preview-${idx}`}
                style={{
                  height: "150px",
                  objectFit: "cover",
                  maxWidth: "180px",
                  borderRadius: "10px",
                  border: "0.5px solid #959595",
                  marginRight: "10px"
                }}
              />
            </div>
          ))}

        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-2">
        <span className="text-muted small">
          {new Date(post.createdAt).toLocaleString()}
        </span>
        <div className="d-flex align-items-center">
          <span className="d-flex me-3 text-muted">
            <UserSearch className="me-1" size={16} /> 
            <p className="mb-0">{post.views ?? 0}</p>
          </span>
          <Button 
            color={'outline-danger'}
            size="sm" 
          >
            ❤️ {(post.likes ?? 0)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PostCard;


